export class SurveyOptionItem {
  constructor(public value: string, public uuid: string) {}
}
